<div class="frame-in">
  <div class="items north-america-3-frame">
    <svg class="road north-america-3">
      <style type="text/css">
        .a{filter:url(#f1);fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:5;stroke-dasharray:15,15}.b{display:none;filter:url(#f2);fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:5;stroke-dasharray:15,15}

      </style>
            <defs><image  width="1640" height="856" id="img1" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABmgAAANYAQMAAAD69fCRAAAAAXNSR0IB2cksfwAAAANQTFRF////p8QbyAAAA6tJREFUeJztzwEJADAMwLDPv+mbGDycRkE75yfzOmBVN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduLpxdePqxtWNqxtXN65uXN24unF14+rG1Y2rG1c3rm5c3bi6cXXj6sbVjasbVzeublzduC7opQNZfWfZ/QAAAABJRU5ErkJggg=="/>
                <filter x="-50%" y="-50%" width="200%" height="200%" id="f1" ><feDropShadow dx="-3.464101615137755" dy="1.9999999999999998" stdDeviation="0" flood-color="#0c3265" flood-opacity=".7"/></filter>
                <filter x="-50%" y="-50%" width="200%" height="200%" id="f2" ><feDropShadow dx="-3.464101615137755" dy="1.9999999999999998" stdDeviation="0" flood-color="#0c3265" flood-opacity=".7"/></filter>
            </defs>
            <g filter="url(#Filter_0)">
                <path fill-rule="evenodd" class="a" d="m9 107c0 0 42.6-94.2 202.2-90.9q1.7 0 3.5 0m29.3 1.9c60.8 5.8 53.8 72.6 197 85 38.8 3.4 57.5-35.9 133-12 27.7 8.8 32.2 41.7 28.6 75.6m-10.6 53.4c-4 15.3-6.5 20.3-9 27-15.6 42.4-97.8 49-145 28-20.6-9.1-40.2-57.2-104-36-40.7 13.5-46.9 58.4-28 80 16 18.3 46 11.4 55 24 26.5 37.1 0.3 50.6 21 99 20.7 48.4 81 83.4 126 63 30.2-13.7 20.5-62.9 84-77 36.8-8.2 59.8-3.5 76.2-5.9"/>
            </g>
            <g filter="url(#Filter_1)">
                <path class="b" d="m679.9 418.3c7-3.9 14.3-10.5 18.1-24.3 13.2-47.5 51.9-60 105-34 20.2 9.8 46.7 5.1 64 5"/>
            </g>
        </svg>
        <div class="country north-america-3"></div>
        <div class="poi quiz quiz-1" (click)="goQuiz()" [ngClass]="{'lock': quizLevel < 13, 'active': quizLevel === 13 && tick2Quiz}"></div>

        @for (zone of zones; track zone) {
<div>
            <div class="country {{zone.class}}" [ngClass]="{'hover': zone.hover}"></div>
        </div>
}

        @for (zone of zones; track zone; let i = $index) {
<div
             class="poi {{zone.class}}"
        [ngClass]="{active: zone.active, 'lock': zone.locked}"
        (mouseenter)="mouseEnter(zone)"
        (mouseleave)="mouseLeave(zone)"
        (click)="selectZone(zone)">
        <span>{{ zone.locked ? '' : zone.number}}</span>
      </div>
    }
  </div>
</div>

<img class="frame-title" src="assets/images/zones/north-america-3/title.png">

<audio id="introductionAudio" (ended)="playBgAudio()">
  <source src="assets/sounds/country.wav" type="audio/wav">
</audio>
<audio id="bgAudio" (ended)="playIntroductionAudio()">
  <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
</audio>

@if (showNotification) {
  <div class="alert-pop-up" style="z-index: 99999999 !important" (click)="closeNotification()">
    <div class="alert-pop-up-in" style="text-align: -webkit-center;">
      <h3>
        This lesson has not been released yet. <br />It is coming soon.
      </h3>
      <button style="margin-right: 0px !important" (click)="closeNotification()" mat-flat-button color="accent" class="alert-button">Ok</button>
    </div>
  </div>
}

<div class="footer">
  <ul class="zone-menu">
    <li>
      @if (!haveAccess('4-1')) {
        <span class="lock"></span>
      }
      @if (haveAccess('4-1')) {
        <a class="menu-item" [routerLink]="[ '/game/south-america-1' ]" routerLinkActive="active">1</a>
      }
    </li>
    <li>
      @if (!haveAccess('4-2')) {
        <span class="lock"></span>
      }
      @if (haveAccess('4-2')) {
        <a class="menu-item" [routerLink]="[ '/game/south-america-2' ]" routerLinkActive="active">2</a>
      }
    </li>
    <li>
      @if (!haveAccess('4-3')) {
        <span class="lock"></span>
      }
      @if (haveAccess('4-3')) {
        <a class="menu-item" [routerLink]="[ '/game/north-america-3' ]" routerLinkActive="active">3</a>
      }
    </li>
  </ul>
  <img class="footer-bg" src="assets/images/zones/north-america-3/footer.png">
</div>

<audio id="continentHover">
  <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
</audio>
<audio id="continentClick">
  <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
</audio>
